import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Log {
  userId?: number | null
  severity: string
  message: string
  page: string
  error?: any | null
  timestamp: number
}

export const useLoggerStore = defineStore('logger', () => {
  const logs = ref([] as Log[])

  function addLog(action: Log) {
    logs.value.push(action)
  }

  function clearLogs() {
    logs.value = []
  }

  async function sendLogs() {
    if (logs.value.length) {
      try {
        clearLogs()
      } catch (e) {
        console.error(e)
      }
    }
  }

  return { logs, addLog, clearLogs, sendLogs }
})
